import React, { useState } from 'react'

export const PortraitPicture = ({ id, genre }) => {
  const [portraitUrl, setPortraitUrl] = useState(null)
  const placeHolderUrl =
    genre === 'Femme'
      ? 'https://interactif.24heures.ch/2021/elections-communales-vd/portraits/female-placeholder.jpg'
      : 'https://interactif.24heures.ch/2021/elections-communales-vd/portraits/male-placeholder.jpg'
  const image = new Image()
  const url = `https://interactif.24heures.ch/2021/elections-communales-vd/portraits/${id}.jpg`

  image.onload = e => {
    setPortraitUrl(url)
  }

  image.onerror = e => {
    setPortraitUrl(placeHolderUrl)
    console.log('Image not found')
  }

  image.src = url

  return (
    <div
      className='portrait'
      style={{
        backgroundImage: `url(${portraitUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center'
      }}
    >
      {/* <img
        style={{
          width: image.width > image.height ? 'auto' : '100%',
          height: image.width > image.height ? '100%' : 'auto'
        }}
        ref={imageNode}
      /> */}
    </div>
  )
}
